module.exports = __webpack_public_path__ + "img/Feature.9f3e7249.jpg";